import React from "react";

import { TrackingVisibleFragment } from "gql-gen";

import icon from "assets/clock.svg";

import { ICell } from "modules/Connection/types";
import { CellBase, CR1 } from "modules/Connection/CellBase";
import trackingFragment from "./trackingFragment.gql";
export const TrackingCell: ICell<TrackingVisibleFragment> = {
  component: props => {
    if (props?.data?.programRole?.role?.skipReportingSteps !== 'none') {
      return null
    }
    return <CellBase {...props}>{() => <CR1>Tracking</CR1>}</CellBase>;
  },
  icon,
  fragment: trackingFragment
};
